import React from 'react';

export interface ISpecialty {
  displayName: string;
}

export const SpecialtyTitle = ({ fields }: any): JSX.Element => {
  return (
    <>
      {fields.Specialties?.length > 0 &&
        fields.Specialties?.map((specialty: ISpecialty, i: any) => (
          <li key={i} className="consultant-specialty-subheading">
            {specialty.displayName}
          </li>
        ))}
      {fields.Specialties?.length === 0 && fields.Specialty && (
        <li className="consultant-specialty-subheading">{fields.Specialty.value}</li>
      )}
    </>
  );
};

export default SpecialtyTitle;
